<template>
	<div class="container_head ">
		<div class="detail">
			<!-- <img :src="img" alt="" class="poster"> -->
			<div class="">
				<div class="title">
                    <span>{{title}}</span>
                    <div class="yf"><span>印发单位：{{yfdw}}</span><span>印发时间：{{time}}</span></div>
                </div>
				<div class="desc" v-html="content"></div>
				<van-divider :style="{ margin: '10px 0' }" />
				<div class="lunbo" v-show="imglist.length>0">
					<van-swipe :autoplay="3000">
						<van-swipe-item v-for="(image, index) in imglist" :key="index">
							<a>
								<img :src="image" width="100%" height="100%" @click="getImg(index)"/>
							</a>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="fujian" v-show="doclist.length>0">
					<div class="fjtitle">
						<span>附件列表</span>
					</div>
					<a class="xiazai disac" download="text" :href="item.src" v-for="(item,index) in doclist" :key="index">
						<span>{{item.name}}</span>
					</a>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	// import showPdf from '../../../components/showpdf.vue'
	import {
		Divider,ImagePreview
	} from 'vant';
	Vue.use(Divider);
	export default {
		// components:{
		// 	showPdf
		// },
		data() {
			return {
			    title:'',
				time:'',
                yfdw:'',
				content:'',
				imglist:[],
				doclist:[],
				// img:require('../../assets/grzx/test.png'),
				id:'',
			};
		},
		mounted(e) {
			this.requestdata()
		},
		methods: {
			changeview(path) {
				this.$router.push(path);
			},
			requestdata(){
				this.id=this.$route.query.id;
				this.$axios.get('/api/v1/wygl/regulations/viewOne', {
					params: {
						id:this.id,//公示详情和快报的
					}
				}).then(res => {
					console.log(res)
					this.title=res.title;
					this.content=res.regulationsContent;
					this.time=res.issuingTime;
                    this.yfdw=res.issuingUnit
					this.imglist = res.imgsurl.split(',') || []
					var doclists = res.docurl.split(',') || []
					var docname  = res.docName.split(',') || []
					this.imglist.pop()
					doclists.pop()
					docname.pop()
					if(doclists.length>0){
						this.doclist = docname.map((item,index)=>{
							return {
								name:item,
								src:doclists[index]
							}
						})
					}
					
				});
			},
			//图片预览
			getImg(i){
				var that = this
				ImagePreview({
					
					images: that.imglist.map(item=>{
						return item
					}),
					showIndex: true,
					loop: true,
					startPosition: i
				});
			},

		}
	};
</script>

<style lang="less" scoped>

.flexcenter {
	display: flex;
	justify-content: center;
	align-items: center;
}

.lunbo {
	// margin-bottom: 5px;
	height: 28%;
	padding: 10px 10px 10px 10px;
	.van-swipe{
		height: 100%;
	}
}
.fujian{
	display: flex;
	flex-direction: column;
    margin-top: 10px;
	.fjtitle{
		height: 16px;
        width: 100%;
        font-size: 15px;
        border-left: 4px solid #28aff6;
        display: flex;
        align-items: center;
        position: relative;
        span {
          margin-left: 10px;
        }
	}
	.xiazai{
		margin-top: 10px;
	}
}
.detail{
	
	background-color: #fff;
	overflow: hidden;
	border-radius: 10px;
	margin: 15px;
	.pd15{
		padding: 15px;
	}
	.poster{
		display: block;
		width: 100%;
		height: 150px;
		object-fit: cover;
	}
	.ckxq{
		overflow: hidden;
		font-size: 13px;
		.time{
			float: left;
		}
		.fbr{
			float: right;
		}
	}
	.title{
		font-size: 16px;
		margin-bottom: 5px;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-bottom: 1px dashed #d8d8d8;
        .yf{
            width: 100%;
            font-size: 12px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-top: 5px;
            margin-bottom: 5px;
        }
	}
	/deep/.desc{
		color: #aaa;
		font-size: 14px;
		word-break: break-all;
		img{
			display: block;
			width: 100%!important;
		}
	}
}
</style>
